import { render, staticRenderFns } from "./categoriesForm.vue?vue&type=template&id=787118e4&"
import script from "./categoriesForm.vue?vue&type=script&lang=js&"
export * from "./categoriesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports